import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getFryChutes(params, signal) {
  return request({
    url: '/fryChutesInfo',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getFryChutesTotal(params, signal) {
  return request({
    url: '/fryChutesInfo/total',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getExelExport(params) {
  return request({
    url: '/fryChutesInfo/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}

export function deleteFryChute(uuid) {
  return request({
    url: `/fryChutesInfo/${uuid}`,
    method: 'delete',
  });
}
